import { createReducer } from '@reduxjs/toolkit'
import { LoadingStatus, ContractorFilters } from 'shared/types'
import * as actions from './actions'

interface State {
  loading: LoadingStatus
  error?: string | null
  filters: ContractorFilters
}

const initialState: State = {
  loading: LoadingStatus.Idle,
  error: null,
  filters: {
    onlyIncomplete: false,
    page: 1,
  },
}

export default createReducer(initialState, builder =>
  builder
    .addCase(actions.setFilters, (state, { payload }) => {
      state.filters = payload
    })
    .addCase(actions.patchFilters, (state, { payload }) => {
      state.filters = {
        ...state.filters,
        ...payload,
      }
    })
    .addCase(actions.clearFilters, state => {
      state.filters = {
        onlyIncomplete: false,
        page: 1,
      }
    })
)
